export const getSrcSet = (items) => items
  .map(([url, width]) => `${url} ${width}`)
  .join(',')

const getProductCardSrcSetAndSizes = (url, width, height) => {
  const publicId = url.substring(url.indexOf('/v'))
  const srcItems = [
    [url, `${width}w`],
    [
      `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_255,h_179,c_fill${publicId}`,
      '255w',
    ],
    [
      `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_330,h_231,c_fill${publicId}`,
      '330w',
    ],
    [
      `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_510,h_357,c_fill${publicId}`,
      '510w',
    ],
    [
      `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_660,h_462,c_fill${publicId}`,
      '660w',
    ],
  ]

  if (width >= 1020 && height >= 714) {
    srcItems.push([
      `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_1020,h_714,c_fill${publicId}`,
      '1020w',
    ])
  }

  const srcSet = getSrcSet(srcItems)

  return {
    srcSet,
    sizes: '(max-width: 767.98px) 510px, (max-width: 991.98px) 330px, 255px',
  }
}

export default getProductCardSrcSetAndSizes
